import { render, staticRenderFns } from "./TypeLoader.vue?vue&type=template&id=634d1a79&"
import script from "./TypeLoader.vue?vue&type=script&lang=js&"
export * from "./TypeLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports